import { render, staticRenderFns } from "./PrePaymentAttachmentModel.vue?vue&type=template&id=8e36838c"
import script from "./PrePaymentAttachmentModel.vue?vue&type=script&lang=js"
export * from "./PrePaymentAttachmentModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e36838c')) {
      api.createRecord('8e36838c', component.options)
    } else {
      api.reload('8e36838c', component.options)
    }
    module.hot.accept("./PrePaymentAttachmentModel.vue?vue&type=template&id=8e36838c", function () {
      api.rerender('8e36838c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/PrePaymentAttachmentModel.vue"
export default component.exports